<template>
    <BaseSection
        v-if="videoUrl"
        width="page-narrow"
    >
        <VideoEmbed
            :url="videoUrl"
            :accessible-url="accessibleVideoUrl"
            :video-title="title"
            :caption="caption"
        />
    </BaseSection>
</template>

<script setup>
defineProps({
    videoUrl: {
        type: String,
        default: ''
    },
    accessibleVideoUrl: {
        type: String,
        default: ''
    },
    caption: {
        type: String,
        default: null
    },
    title: {
        type: String,
        default: null
    }
});
</script>
